import type { ImpactCertificateApi, ImpactReportApi } from 'v2/interfaces/impactMeter';

import { apiServiceProxy, type ApiServiceProxy } from './api-proxy';

class ImpactMeterService {
  constructor(private readonly apiService: ApiServiceProxy) {}

  public getReport = (userId: number) => {
    return this.apiService.get<ImpactReportApi>(`/users/${userId}/impact-report`).then(response => response.data);
  };

  public createCertificate = (userId: number, name: string) => {
    return this.apiService
      .post<ImpactCertificateApi>(`/users/${userId}/impact-certificate`, { name })
      .then(response => response.data);
  };
}

const impactMeterService = new ImpactMeterService(apiServiceProxy);

export default impactMeterService;
